import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      document.getElementById('scroll-target')?.scrollIntoView();
    }, [pathname]);

    return null;
}

export default ScrollToTop;